import {useEffect} from 'react';

import {shallowEqual, useDispatch, useSelector} from 'react-redux';

import {DOCTOR_DETAILS_DEFAULT} from 'constants/product';
import {getDrawerState} from 'desktop/pages/success/selectorsV2';
import {
    changeField,
    setErrorsSuccessPage,
    setIsAutocompleteModeEnabled,
} from 'desktop/pages/success/store/actions/orderItems/orderItems';
import {getValidatedItems} from 'desktop/pages/success/store/selectors/orderItems/orderItems';
import {getCustomerFullName} from 'desktop/pages/success/store/selectors/orderLast/orderLast';
import {ApplicationStoreType} from 'desktop/store';
import {
    DoctorDetailsType,
    MANUALLY_FILLING_METHOD,
    SUCCESS_PAGE_FIELDS_DEFAULT,
} from 'types/successPage';

/**
 * Send initial data when manual doctor rendered
 */
export const useInitializeManualDoctorWrapper = () => {
    const {customerFullName, item, validatedItems} = useSelector(
        (store: ApplicationStoreType) => ({
            customerFullName: getCustomerFullName(store),
            item: getDrawerState(store).item,
            validatedItems: getValidatedItems(store),
        }),
        shallowEqual,
    );

    const dispatch = useDispatch();
    const parsedItem = validatedItems?.[item?.id || ''] as DoctorDetailsType;

    useEffect(() => {
        dispatch(
            setIsAutocompleteModeEnabled({
                isAutocompleteModeEnabled: false,
                orderItemId: String(item?.id),
            }),
        );
        dispatch(
            setErrorsSuccessPage({
                [String(item?.id)]: {
                    ...DOCTOR_DETAILS_DEFAULT,
                },
            }),
        );
        dispatch(
            changeField({
                ...SUCCESS_PAGE_FIELDS_DEFAULT,
                doctorDetails: {
                    ...DOCTOR_DETAILS_DEFAULT,
                    filling_method: MANUALLY_FILLING_METHOD,
                    patientName: customerFullName || '',
                },
                fileType: '',
                orderItemId: String(item?.id),
                sendBy: item?.prescription?.send_by || 0,
                type: 'success',
            }),
        );
    }, []);

    const resetError = (key: string) => {
        dispatch(
            setErrorsSuccessPage({
                [String(item?.id)]: {
                    ...DOCTOR_DETAILS_DEFAULT,
                    ...parsedItem,
                    [key]: '',
                },
            }),
        );
    };

    return {resetError};
};
